import { createGenericSlice } from '../genericSlice.js';
import initialState from './initialState.js';
import '@reduxjs/toolkit';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';

const categorySlice = createGenericSlice({
    name: 'category',
    initialState,
    reducers: {
        updateCategory: (state, action) => {
            state.category = action.payload;
        },
    },
    extraReducers: () => { },
});
const { updateCategory } = categorySlice.actions;
var index = categorySlice.reducer;

export { index as default, updateCategory };
//# sourceMappingURL=index.js.map
